import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white" data-id="element-149" data-mp="2z3h1s7e1j7ij">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20" data-id="element-150" data-mp="3mt31qx28lqrl">
        <SectionHeading title={<>Questions I get <em className="text-teal-dark" data-id="element-152" data-mp="3rrmo2ykqt4kh">all the time</em></>} data-id="element-151" data-mp="3mtl3uabkyz7f" />

        <ul className="mt-10 space-y-3" data-id="element-153" data-mp="3rtz2x2v7eytb">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-154" data-mp="3i1kz84kkfi4i" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-155" data-mp="9lrjvt1z0cp1">
                  <span className="text-[17px] font-black leading-snug text-navy" data-id="element-156" data-mp="20oduzb2jseje">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-157" data-mp="1vpspaw4j12nk" />
                </button>
                <AnimatePresence initial={false} data-id="element-158" data-mp="2jfwu36tgb8g5">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-159" data-mp="2eiwmgrgydxmx">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-160" data-mp="z2ef3gpgu1xz">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-161" data-mp="1jsi9zouj5ay6">
          <CTAButton label="I'm ready — give me instant access" data-id="element-162" data-mp="1nrqzuimg8oog" />
        </div>
      </div>
    </section>;
}